// extracted by mini-css-extract-plugin
export default {"body":"CreateCalculationModal_body__dIpkV","actions":"CreateCalculationModal_actions__LYXWc"};